<template>
  <div>
    <el-input v-model="listForm.remark" placeholder="请输入备注信息" />
    <div class="dialog-footer" style="text-align: center">
      <el-button @click.native="cancel" size="medium">关闭</el-button>
      <el-button type="primary" size="medium" @click.native="submit" v-loading="submitLoading">提交</el-button>
    </div>
  </div>
</template>

<script>
import { postFormData } from '@/api/api';
import { updateRouteTransformRemark } from '@/api/url';
export default {
  props: {
    value: Object
  },
  data() {
    return {
      listForm: this.value.listForm,
      submitLoading: false
    }
  },
  methods: {
    cancel() {
      this.$emit('close');
    },

    submit() {
      if(!this.listForm.remark) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '备注内容不能为空',
          type: 'warning'
        });
        return false
      }
      let param = {};
      param['id'] = this.listForm.id;
      param['remark'] = this.listForm.remark;
      postFormData(updateRouteTransformRemark, param).then((data) => {
        let {code,msg} = data;
        if(code == 200){
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          });
          this.$emit('confirm', param);
        }else{
          this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
        this.submitLoading = false;
      })
          .catch(function(response){
            this.submitLoading = false;
          })
    }
  },
  mounted() {

  }
}
</script>

<style>

</style>
